const enum ActivityQueryTypes {
  INCOMING = "incoming",
  AI_INCOMING = "ai_incoming",
  OUTGOING = "outgoing",
  SMS = "sms",
  LIVE_CHAT = "livechat",
  ALL = "",
  MESSAGES = "receptionistmessage",
  VOICEMAIL = "voicemailmessage",
}

export const activityQueryVals = {
  INCOMING: "incoming",
  OUTGOING: "outgoing",
  SMS: "sms",
  LIVE_CHAT: "livechat",
  ALL: "",
  MESSAGES: "receptionistmessage",
  VOICEMAIL: "voicemailmessage",
};

export default ActivityQueryTypes;
